module.exports = __webpack_public_path__ + "static/media/mob-banner1.dd5c9408.png";